import React, { useEffect, useState } from "react";
import { Box, Checkbox, Divider, Flex, HStack, Text } from "@chakra-ui/react";
import { ChatDeleteMenu, CustomTextComponent } from "@components/index";
import useCustomTheme from "@root/hooks/useCustomTheme";
import { userManagmenetMonthDate } from "@root/utils/helpers";
import { HistoryItemProjectChip } from "./historyItemProjectChip";

export const ChatHistory: React.FC<IChatHistory> = ({
  data,
  parentSelectedChat,
  onClick = () => {},
  onRemove = () => {},
  onSeletionChange = () => {},
}) => {
  const { isDarkTheme } = useCustomTheme() || {};
  const [selectedChats, setSelectedChats] = useState<Record<string, boolean>>(
    {}
  );
  const [hoveredChatId, setHoveredChatId] = useState<string | null>(null);

  const handleCheckboxChange = (id: string, isChecked: boolean) => {
    setSelectedChats((prev) => {
      const updatedSelectedChats = { ...prev, [id]: isChecked };
      if (typeof onSeletionChange === "function") {
        onSeletionChange(updatedSelectedChats);
      }

      return updatedSelectedChats;
    });
  };

  useEffect(() => {
    if (parentSelectedChat) {
      setSelectedChats(parentSelectedChat);
    }
  }, [parentSelectedChat]);

  const handleRemoveChat = (userChat: any) => {
    if (typeof onRemove === "function") {
      onRemove({ chat: userChat });
    }
  };

  const handleChatClick = (userChat: any) => {
    if (typeof onClick === "function") {
      onClick({ chat: userChat });
    }
  };

  const getModelLabel = (model: any) => {
    const modelOptions = JSON.parse(process.env.REACT_APP_CHAT_MODELES ?? "[]");
    const modelOption =
      modelOptions?.find((item: any) => item.value === model)?.label || "";
    return modelOption;
  };

  return (
    <Flex flexDirection="column">
      <Divider
        marginLeft={"120px"}
        marginTop={"-10px"}
        marginBottom={"20px"}
        width={"840px"}
      />
      <Flex
        alignItems="center"
        justifyContent="space-between"
        align="flex-start"
        width="100%"
      ></Flex>

      {data?.chats?.map((userChat: any) => {
        const isChecked = selectedChats[userChat?.id] || false;
        const isHovered = hoveredChatId === userChat?.id;
        return (
          <Flex
            key={userChat?.id}
            alignItems="center"
            mt={2}
            onMouseEnter={() => setHoveredChatId(userChat?.id)}
            onMouseLeave={() => setHoveredChatId(null)}
          >
            <Checkbox
              marginTop="-65px"
              isChecked={isChecked}
              onChange={(e) =>
                handleCheckboxChange(userChat?.id, e.target.checked)
              }
              sx={{
                borderColor: "#C5C7D0",
              }}
              visibility={isHovered || isChecked ? "visible" : "hidden"}
              mr={2}
            />

            <Box
              p={4}
              width={"1100px"}
              borderRadius="16px"
              border="1px solid"
              borderColor={
                isChecked ? "#337CC1" : isDarkTheme ? "transparent" : "#E4EBF0"
              }
              onClick={() => handleChatClick(userChat)}
              _hover={{
                cursor: "pointer",
                boxShadow: "0px 4px 4px 0px #2023261A",
              }}
              backgroundColor={isDarkTheme ? "#8D919E1A" : "theme.white"}
            >
              <Flex justifyContent="space-between" alignItems="center">
                <Box>
                  <Flex gap={"8px"}>
                    <Text
                      width={"fit-content"}
                      left={"8px"}
                      border={"1px solid"}
                      borderColor={"#0ECCF2"}
                      borderRadius={"4px"}
                      backgroundColor={"white"}
                      padding={"2px 4px"}
                      fontWeight={"400"}
                      fontSize={"11px"}
                      color={"#337CC1"}
                    >
                      {getModelLabel(userChat?.model)}
                    </Text>
                    <HStack>
                      <HistoryItemProjectChip pid={userChat?.project_id} />
                      <Text color="gray.graytText" fontSize="sm">
                        날짜:{" "}
                        {userManagmenetMonthDate(userChat?.updatedAt) ||
                          userManagmenetMonthDate(userChat?.createdAt) ||
                          "N/A"}
                      </Text>
                    </HStack>
                  </Flex>
                  <CustomTextComponent
                    title={userChat?.name || ""}
                    description={userChat?.answer || ""}
                    titleSize="14px"
                    titleWeight={400}
                    descriptionSize="14px"
                    descriptionWeight={400}
                  />
                </Box>

                {(isHovered || isChecked) && (
                  <Box
                    border="1px solid #C5C7D0"
                    borderRadius="50%"
                    height="32px"
                    width="32px"
                  >
                    <Box marginTop="1px" marginLeft="2px">
                      <ChatDeleteMenu
                        deleteAll={false}
                        onRemoveClick={() => handleRemoveChat(userChat)}
                        isDisabled={false}
                        chat={userChat}
                      />
                    </Box>
                  </Box>
                )}
              </Flex>
            </Box>
          </Flex>
        );
      })}
    </Flex>
  );
};
